var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('DxTextBox',{attrs:{"disabled":_vm.model.disabled,"width":_vm.getString(_vm.model.options, 'width', '100%'),"value":_vm.content.value},on:{"update:value":function($event){return _vm.$set(_vm.content, "value", $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }